import { httpInstancePublicProvider } from "@/services/httpInstance";
import { CommerceProfilesQueryDto } from "./types";

const getCommerceProfiles = async ({
  page,
  pageSize,
  documentNumber,
  commercialName,
  legalName,
  email,
}: CommerceProfilesQueryDto) => {
  let endpoint = `crm_helper/v1/crm/commerce_profiles_back_office?page=${page}&pageSize=${pageSize}`;

  if (documentNumber) endpoint += `&documentNumber=${documentNumber}`;

  if (commercialName) endpoint += `&commercialName=${commercialName}`;

  if (legalName) endpoint += `&legalName=${legalName}`;

  if (email) endpoint += `&email=${email}`;

  try {
    const response = await httpInstancePublicProvider.get(endpoint);

    return response.data;
  } catch (error: any) {
    console.error("❌ Error en getCommerceProfiles:", {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return error?.response;
  }
};

export default getCommerceProfiles;
